module.exports = __webpack_public_path__ + "barbados.svg?9f7ce6e87172a3f2be8cd390ecb45ad7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/barbados.svg
// module id = 105
// module chunks = 10